var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.12 70.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M57.17,7.18m5.95,13.34V65a5.45,5.45,0,0,1-5.44,5.44l-44.32-.33a5.44,5.44,0,0,1-5.43-5.44V59.49h2.65v5.13a2.8,2.8,0,0,0,2.79,2.8l44.32.33A2.81,2.81,0,0,0,60.48,65V23.13H46.27a6,6,0,0,1-6-5.95V3l-27-.31a2.77,2.77,0,0,0-2.75,2.78V35.69H7.93V5.42A5.42,5.42,0,0,1,13.35,0l29,.33h.62Zm-3.85,0L43,4.18v13a3.31,3.31,0,0,0,3.31,3.31Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 38.34,
    width: 55.4,
    height: 19.39,
    rx: 2.54,
    style: {
      fill: "#71c51a"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(11.76 53.97)",
    style: {
      fontSize: "16.465299606323242px",
      fill: "#fff",
      fontFamily: "Nunito-Black, Nunito Black",
      fontWeight: 800
    }
  }, "X", /*#__PURE__*/React.createElement("tspan", {
    x: 11.29,
    y: 0,
    style: {
      letterSpacing: "-0.007977240584165136em"
    }
  }, "L"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 20.58,
    y: 0
  }, "S"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsIcon);
export default __webpack_public_path__ + "static/media/xls_icon.6d44500e85ad3425030a53e0c00517f5.svg";
export { ForwardRef as ReactComponent };